import { defineComponent as _defineComponent } from 'vue';
import { ref, watch } from "vue";
import { useUndoRedoStore } from "@/stores/undoRedoStore";
import ActivityPanel from "../Panels/ActivityPanel.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UndoRedoStack',
    props: {
        storeId: null
    },
    setup(__props) {
        const props = __props;
        const currentStore = ref(useUndoRedoStore(props.storeId));
        watch(() => props.storeId, (id) => (currentStore.value = useUndoRedoStore(id)));
        function onInput(event) {
            const value = event.target.value;
            const valueNumber = parseFloat(value);
            const nonNanValue = isNaN(valueNumber) ? 0 : valueNumber;
            currentStore.value.savedUndoActions = nonNanValue;
            savedUndoActions.value = nonNanValue;
        }
        const savedUndoActions = ref(currentStore.value.savedUndoActions);
        function updateSavedUndoActions() {
            savedUndoActions.value = currentStore.value.savedUndoActions;
        }
        return { __sfc: true, props, currentStore, onInput, savedUndoActions, updateSavedUndoActions, ActivityPanel };
    }
});
